<app-button-close *ngIf="shouldDisplayCloseButton"
                  [defaultRoute]="[{content: 'home', focus: ['home', 'informations']}, 'content']"
                  appNavigateBack>
</app-button-close>
<ng-content></ng-content>
